module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-6-small-7108912018d911b2fe6f6c0a0b303c73.jpg";